class StatusCotacaoEnum {
  constructor() {
    this.EM_ANDAMENTO = 1;
    this.AGENDADO = 2;
    this.ENCERRADO = 3;
  }

  getTiposLabel() {
    return [
      {
        label: 'Em andamento',
        value: this.EM_ANDAMENTO,
        active: true,
      },
      {
        label: 'Agendado',
        value: this.AGENDADO,
        active: true,
      },
      {
        label: 'Encerrado',
        value: this.ENCERRADO,
        active: true,
      },
    ];
  }

  getTipo(status) {
    return this.getTiposLabel()
      .filter(label => label.value === status)
      .shift();
  }
}

export default new StatusCotacaoEnum();
